import { Button, DropdownMenu, Input } from 'components/atoms';
import { IUseColumnsVisibility } from 'hooks/useColumnsVisibility';
import useComponentVisible from 'hooks/useComponentVisible';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { PiColumnsPlusRight } from 'react-icons/pi';
import {
  BUTTON_VARIANT,
  IButtonProps,
} from 'types/components/button/button.interface';
import {
  II18nextPrefix,
  IJustifyPositionProps,
} from 'types/components/components.interface';
import { IStandardEnum } from 'types/global/enum.interface';
import { enumToObject } from 'utils/global/object.utils';

interface ITableCustomColumnsDropdownProps
  extends II18nextPrefix,
    IButtonProps,
    IJustifyPositionProps {
  icon?: ReactNode;
  columns: IStandardEnum<number>;
  visibility: IUseColumnsVisibility<number>;
  lastUnvisibleColumn?: number;
  customI18next?: string;
}

const TableCustomColumnsButtonDropdown = ({
  icon = <PiColumnsPlusRight />,
  variant = BUTTON_VARIANT.default,
  columns,
  i18nextPrefix,
  visibility,
  lastUnvisibleColumn,
  customI18next = '.table',
  justifyPosition = 'end',
  ...props
}: ITableCustomColumnsDropdownProps) => {
  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);
  return (
    <Button
      variant={variant}
      onlyIcon
      {...props}
      onClick={handleComponentVisible}
      outsideChildren={
        <DropdownMenu
          ref={ref}
          visible={isComponentVisible}
          justifyPosition={justifyPosition}
          style={{ padding: '10px' }}>
          <div className='flex flex-col w-full'>
            {enumToObject(columns, lastUnvisibleColumn).map(column => (
              <Input.Checkbox
                key={column.key}
                name={column.key}
                label={t(`${i18nextPrefix}${customI18next}.${column.key}`)}
                checked={!visibility.hide(column.value)}
                disabled={visibility.disable(column.value)}
                onChange={() => visibility.toogleColumn(column.value)}
              />
            ))}
          </div>
        </DropdownMenu>
      }>
      <Button.Icon icon={icon} />
    </Button>
  );
};

export default TableCustomColumnsButtonDropdown;
